
<Teleport :to="teleport">
  <!-- 遮罩层 -->
  <Overlay
    v-if="overlay"
    :visible="visible"
    :overlay-class="overlayClass"
    :z-index="normalizedZIndex"
    :duration="duration"
    :lock-scroll="lockScroll"
    @click="onClickOverlay"
  />
  <!-- 弹窗内容 -->
  <Transition
    :name="n(`--pop-${position}`)"
    :duration="animationDuration"
    @after-enter="onOpened"
    @after-leave="onClosed"
  >
    <div
      v-show="visible"
      :class="[classes(n(), n('$--box'), n(`--${position}`)), popAttrs.class]"
      :style="{
        ...popStyle,
        ...popAttrs.style,
      }"
      role="dialog"
      aria-modal="true"
      v-bind="$attrs"
    >
      <slot v-if="showSlot" />
    </div>
  </Transition>
</Teleport>
